import {ChangeDetectionStrategy, Component, inject, model, output, signal} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {DirectusLoader, LanguageOption} from '@frontend/directus';
import {ModelFieldSelectComponent} from '../../inputs/model-field/model-field-select/model-field-select.component';
import {BaseDialogComponent} from '../base-dialog/base-dialog.component';

@Component({
  selector: 'app-language-select-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseDialogComponent, ModelFieldSelectComponent],
  templateUrl: './language-select-dialog.component.html',
})
export class LanguageSelectDialogComponent {
  private readonly directusLoader = inject(DirectusLoader);
  private readonly translocoService = inject(TranslocoService);

  readonly visible = model<boolean>(false);

  readonly languageSelected = output<string>();

  protected readonly languageOptions: LanguageOption[] = this.directusLoader.getLanguageOptions();

  protected readonly language = signal<string>(this.translocoService.getActiveLang());

  protected onApply(): void {
    this.languageSelected.emit(this.language());
    this.visible.set(false);
  }
}
